import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Las contraseñas no coinciden.'); return; }
    if (password.length < 8) { setError('Mínimo 8 caracteres.'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error. El link puede haber expirado.');
    }
    setLoading(false);
  };

  const inputStyle = {
    width: '100%', height: '44px', padding: '0 44px 0 12px',
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.09)',
    borderRadius: '10px', fontSize: '14px', color: '#E2E8F0',
    outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.15s',
  };

  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: 600, color: '#475569',
    marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.06em',
  };

  if (!token) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#090C11' }}>
        <div style={{ textAlign: 'center', color: '#F87171' }}>
          <p style={{ fontSize: '16px' }}>Link inválido.</p>
          <Link to="/forgot-password" style={{ color: '#00C878', fontSize: '14px' }}>Solicitar uno nuevo</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: 'radial-gradient(ellipse at 50% 40%, rgba(0,200,120,0.06) 0%, #090C11 55%)',
      padding: '24px',
    }}>
      <motion.div
        initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        style={{ width: '100%', maxWidth: '380px' }}
      >
        <div style={{ marginBottom: '32px', height: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
          <img src="/nexia-logo.png" alt="Nexia" style={{ height: '185px', width: 'auto', marginTop: '-14px' }} />
        </div>

        <div style={{ background: '#10151E', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '16px', padding: '32px 28px' }}>
          <AnimatePresence mode="wait">
            {!done ? (
              <motion.div key="form" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                <p style={{ fontSize: '17px', fontWeight: 700, color: '#E2E8F0', margin: '0 0 4px' }}>
                  Nueva contraseña
                </p>
                <p style={{ fontSize: '13px', color: '#475569', margin: '0 0 24px' }}>
                  Elige una contraseña segura de al menos 8 caracteres.
                </p>

                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div>
                    <label style={labelStyle}>Nueva contraseña</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        value={password} onChange={e => setPassword(e.target.value)}
                        required placeholder="Mínimo 8 caracteres"
                        style={inputStyle}
                        onFocus={e => e.target.style.borderColor = 'rgba(0,200,120,0.5)'}
                        onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.09)'}
                      />
                      <button type="button" onClick={() => setShowPassword(s => !s)}
                        style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#475569', display: 'flex' }}>
                        <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          {showPassword
                            ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                            : <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></>
                          }
                        </svg>
                      </button>
                    </div>
                  </div>

                  <div>
                    <label style={labelStyle}>Confirmar contraseña</label>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      value={confirm} onChange={e => setConfirm(e.target.value)}
                      required placeholder="Repite la contraseña"
                      style={{ ...inputStyle, paddingRight: '12px' }}
                      onFocus={e => e.target.style.borderColor = 'rgba(0,200,120,0.5)'}
                      onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.09)'}
                    />
                  </div>

                  <AnimatePresence>
                    {error && (
                      <motion.p initial={{ opacity: 0, y: -4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
                        style={{ margin: 0, padding: '10px 14px', background: 'rgba(239,68,68,0.07)', border: '1px solid rgba(239,68,68,0.18)', borderRadius: '10px', fontSize: '13px', color: '#F87171' }}>
                        {error}
                      </motion.p>
                    )}
                  </AnimatePresence>

                  <button type="submit" disabled={loading} style={{
                    width: '100%', height: '44px', borderRadius: '10px',
                    fontSize: '14px', fontWeight: 700, border: 'none',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    background: loading ? '#1A2030' : '#00C878',
                    color: loading ? '#475569' : '#000', marginTop: '4px',
                  }}>
                    {loading ? 'Guardando...' : 'Guardar contraseña'}
                  </button>
                </form>
              </motion.div>
            ) : (
              <motion.div key="done" initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }}
                style={{ textAlign: 'center', padding: '8px 0' }}>
                <div style={{ fontSize: '44px', marginBottom: '16px' }}>✅</div>
                <p style={{ fontSize: '16px', fontWeight: 700, color: '#E2E8F0', margin: '0 0 8px' }}>
                  ¡Contraseña actualizada!
                </p>
                <p style={{ fontSize: '13px', color: '#475569', margin: 0 }}>
                  Redirigiendo al inicio de sesión...
                </p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {!done && (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Link to="/login" style={{ fontSize: '13px', color: '#475569', textDecoration: 'none' }}
              onMouseEnter={e => e.target.style.color = '#00C878'}
              onMouseLeave={e => e.target.style.color = '#475569'}>
              ← Volver al inicio de sesión
            </Link>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default ResetPassword;
